import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useAuthKakao from 'app/hook/sns/useAuthKakao';
import useAuthNaver from 'app/hook/sns/useAuthNaver';
import useAuthGoogle from 'app/hook/sns/useAuthGoogle';
import useAuthApple from 'app/hook/sns/useAuthApple';
import { snsAuthorizeForTypes } from 'app/libs/snsUtils';
import { LOGIN_RETURN_URL_KEY } from 'app/constants/login';
import { testFullUrl } from 'app/libs/regEx';
import { setSessionItem, getSessionItem } from 'app/libs/storageUtils';
import qs from 'query-string';
import useEncarUrlBuilder from 'app/hook/common/useEncarUrlBuilder';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import mobileAppBridge from 'app/libs/MobileAppBridge';

export default function useSnsLogin() {
	const location = useLocation();
	const history = useHistory();
	const { authorizeKakao } = useAuthKakao();
	const { authorizeNaver } = useAuthNaver();
	const { authorizeGoogle } = useAuthGoogle();
	const { authorizeApple } = useAuthApple();
	const { backpath, returnUrl, popupMode, shouldCheckSellRedirect } = useMemo(() => qs.parse(location.search), [location.search]);
	const encarUrlBuilder = useEncarUrlBuilder();
	const ua = useSsrUserAgent();

	const returnFullUrl = useMemo(() => {
		const fullLegacyUrl = testFullUrl(backpath) ? backpath : encarUrlBuilder().pc(backpath).mobile(backpath);
		const fullFemUrl = testFullUrl(returnUrl) ? returnUrl : `${window.location.protocol}//${window.location.host}${returnUrl}`;
		if (backpath) return fullLegacyUrl;
		if (returnUrl) return fullFemUrl;
		return '';
	}, [backpath, encarUrlBuilder, returnUrl]);

	const goEncarLogin = () => {
		const loginUrlKey = getSessionItem(LOGIN_RETURN_URL_KEY);

		if (ua().isApp) mobileAppBridge().encarLogin(loginUrlKey, true);
		else {
			history.replace(
				`/encar-login?${qs.stringify({
					...(loginUrlKey && { returnUrl: loginUrlKey }),
				})}`,
			);
		}
	};

	const handleSnsClick = (platform, hasReturnUrl = false, type = snsAuthorizeForTypes.LOGIN) => {
		if (platform === 'google' && ua().isKakao) {
			// 카카오 브라우저에서는 구글 로그인이 안되어서 외부 브라우저로 오픈(카카오 웹뷰 기능으로 막힐 수 있음)
			alert('구글 로그인을 위해 기본 브라우저에서 계속해주세요.');
			const currentProtocal = window.location.protocol;
			const currentHost = window.location.host;
			const currentPathname = window.location.pathname;
			const currentSearch = window.location.search;

			const encodedUrl = encodeURIComponent(`${currentProtocal}//${currentHost}${currentPathname}${currentSearch}`);

			window.location.href = `kakaotalk://web/openExternal?url=${encodedUrl}`;
			return;
		}

		if (!hasReturnUrl) {
			setSessionItem(LOGIN_RETURN_URL_KEY, returnFullUrl);
		}

		const options = { backPath: backpath, returnUrl, popupMode, shouldCheckSellRedirect };
		if (platform === 'kakao') authorizeKakao(type, options);
		if (platform === 'naver') authorizeNaver(type, options);
		if (platform === 'google') authorizeGoogle(type, options);
		if (platform === 'apple') authorizeApple(type, options);
		if (platform === 'encar') goEncarLogin();
	};

	return {
		handleSnsClick,
	};
}
